import { ref } from 'vue';

/**
 * Флаг анимации вставки/удаления элемента в виртуальном списке.
 * Когда true — на строках виртуального списка включается CSS transition (класс .vrow-animate),
 * и изменение translateY анимируется плавно. Когда false — transition отключён,
 * чтобы не тормозить обычный скролл.
 *
 * Используется в store (insertElementLocally / removeElementLocally) и VirtualAnalyticsList.
 */
export const insertAnimActive = ref(false);
